import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const I18N_TEXT: any = {
    us: {
        title: 'Newsfeed',
        desc: 'Catch the most recent EcoFlow news, upcoming event info and much more!',
        news1: {
            title: 'EcoFlow DELTA Pro 3 Launch!',
            desc: 'We are beyond excited to announce the launch of the EcoFlow DELTA Pro 3! Special incentives and product insights await you. Check inside for more! ',
            link: 'https://www.facebook.com/groups/deltaprolaunch/permalink/1862540984212748',
        },
        learn_more: 'Learn more',
    },
};

export default function B() {
    const { useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const text = I18N_TEXT[locale] || I18N_TEXT.us;
    const cards: any = [
        {
            img: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719296880769/community_b_1366.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719296880590/community_b_1024.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719296880425/community_b_375.jpg',
            ],
            title: text.news1.title,
            desc: text.news1.desc,
            link: text.news1.link,
        },
    ];

    return (
        <div id="community-page-B" className={`community-page-B ${css['community-page-B']}`}>
            <h2 className="title">{text.title}</h2>
            <p className="desc">{text.desc}</p>
            <div className="cards">
                {cards?.map((card: any, k: number) => (
                    <div className="card" key={k}>
                        <div className="card-img">
                            <EFPicture src={card.img[0]} srcPad={card.img[1]} srcMobile={card.img[2]} alt={card?.title} />
                        </div>
                        <div className="card-info">
                            <p className="card-title">{card?.title}</p>
                            <p className="card-desc">{card?.desc}</p>
                            <Link
                                className="card-link"
                                href={card?.link}
                                ariaLabel={card?.title}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'community_button',
                                    list_name: card?.title,
                                    button_name: card?.link,
                                }}
                            >
                                {text.learn_more}
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
